//GeneratorFlag:[NoChange]
import Tenant from './tenant';

export default {Tenant}
export{Tenant}